
const packageIds = [
  'dpp_plan_tier3_012mo',
  'dpp_plan_tier3_024mo',
  'dpp_plan_tier3_036mo',
  'dpp_plan_tier3_060mo',
  'dpp_plan_tier3_120mo',
  'dpp-intl-solution-tier6'
];

export default ({
  match: (item) => {
    return packageIds.includes(item.packageId);
  },
  rules: {
    design: '1',
    label: 'ECOMMERCE_PLAN',
    description: 'DOMAIN_NAME',
    savings: 'PERCENT_OFF',
    durationUnit: 'YEAR',
    rollupPricing: true,
    annotate: true
  }
});
